import { I2PEnvironment } from '@price-for-profit/micro-services';
import { Dashboard } from '@mui/icons-material';

const routeConfig: EnvironmentNavigation[] = [
    {
        application: {
            applicationName: 'Drive Account',
            env: {
                local: {
                    applicationId: '9425f1a7-2007-4aa7-8a40-30ce4feb977d',
                    deployedUrl: 'https://localhost:5001/apps/account',
                },
                dev: {
                    applicationId: '9425f1a7-2007-4aa7-8a40-30ce4feb977d',
                    deployedUrl: 'https://edgewater.dev.insight2profit.com/apps/account',
                },
                sandbox: {
                    applicationId: '4bb6a5ea-ed7b-4f2c-8611-b4ae271c051a',
                    deployedUrl: 'https://edgewater.sandbox.insight2profit.com/apps/account',
                },
                prod: {
                    applicationId: 'd11e86a2-cbf1-4ac4-a23e-4cf648c2c8ce',
                    deployedUrl: 'https://edgewater.insight2profit.com/apps/account',
                },
            },
        },
        links: [
            {
                title: 'Analytics Dashboard',
                url: '/analytics',
                icon: <Dashboard sx={{ color: 'primary.main' }} />,
            },
        ],
    },
];

interface NavigationLink {
    title: string;
    url: string;
    icon?: JSX.Element;
}

interface EnvironmentNavigation {
    application: {
        applicationName: string;
        env: Record<Exclude<I2PEnvironment, 'model'> | 'local', { applicationId: string; deployedUrl: string }>;
    };
    links: NavigationLink[];
}

interface DriveAccountNavigation {
    application: {
        applicationId: string;
        applicationName: string;
        deployedUrl: string;
    };
    links: NavigationLink[];
    local?: boolean;
}

interface BuildDriveAccountNavigationProps {
    applicationId: string;
    environment: Exclude<I2PEnvironment, 'model'>;
    useLocal?: boolean;
}

export function buildDriveAccountNavigation({
    applicationId,
    environment,
    useLocal,
}: BuildDriveAccountNavigationProps): DriveAccountNavigation[] {
    const localEnvironment = environment === 'dev' && useLocal ? 'local' : environment;

    return routeConfig.map<DriveAccountNavigation>(({ links, application }) => {
        const envConfig = application.env[localEnvironment];
        return {
            application: {
                applicationName: application.applicationName,
                ...envConfig,
            },
            links,
            local: applicationId === envConfig.applicationId,
        };
    });
}

export const showHamburger = routeConfig.length > 1;
